var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.199951,
    y: 0.861328,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#ECE3FB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3981_24954",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 29,
    height: 29
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.19995,
    y: 8.86133,
    width: 28,
    height: 28,
    fill: "#915DE8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3981_24954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2 25.7488L24.4458 27.0905C24.6597 27.2266 24.8687 27.2217 25.0729 27.0759C25.277 26.9301 25.35 26.7308 25.2916 26.478L24.7083 23.9405L26.6916 22.2197C26.8861 22.0447 26.9444 21.8356 26.8666 21.5926C26.7888 21.3495 26.6138 21.2183 26.3416 21.1988L23.7458 20.9947L22.725 18.5738C22.6277 18.3405 22.4527 18.2238 22.2 18.2238C21.9472 18.2238 21.7722 18.3405 21.675 18.5738L20.6541 20.9947L18.0583 21.1988C17.7861 21.2183 17.6111 21.3495 17.5333 21.5926C17.4555 21.8356 17.5138 22.0447 17.7083 22.2197L19.6916 23.9405L19.1083 26.478C19.05 26.7308 19.1229 26.9301 19.327 27.0759C19.5312 27.2217 19.7402 27.2266 19.9541 27.0905L22.2 25.7488ZM18.2916 32.1947H15.2C14.5583 32.1947 14.009 31.9662 13.552 31.5092C13.0951 31.0523 12.8666 30.503 12.8666 29.8613V26.7697L10.6208 24.4947C10.4069 24.2613 10.2416 24.0037 10.125 23.7217C10.0083 23.4398 9.94995 23.153 9.94995 22.8613C9.94995 22.5697 10.0083 22.2829 10.125 22.0009C10.2416 21.719 10.4069 21.4613 10.6208 21.228L12.8666 18.953V15.8613C12.8666 15.2197 13.0951 14.6704 13.552 14.2134C14.009 13.7565 14.5583 13.528 15.2 13.528H18.2916L20.5666 11.2822C20.8 11.0683 21.0576 10.903 21.3395 10.7863C21.6215 10.6697 21.9083 10.6113 22.2 10.6113C22.4916 10.6113 22.7784 10.6697 23.0604 10.7863C23.3423 10.903 23.6 11.0683 23.8333 11.2822L26.1083 13.528H29.2C29.8416 13.528 30.3909 13.7565 30.8479 14.2134C31.3048 14.6704 31.5333 15.2197 31.5333 15.8613V18.953L33.7791 21.228C33.993 21.4613 34.1583 21.719 34.275 22.0009C34.3916 22.2829 34.45 22.5697 34.45 22.8613C34.45 23.153 34.3916 23.4398 34.275 23.7217C34.1583 24.0037 33.993 24.2613 33.7791 24.4947L31.5333 26.7697V29.8613C31.5333 30.503 31.3048 31.0523 30.8479 31.5092C30.3909 31.9662 29.8416 32.1947 29.2 32.1947H26.1083L23.8333 34.4405C23.6 34.6544 23.3423 34.8197 23.0604 34.9363C22.7784 35.053 22.4916 35.1113 22.2 35.1113C21.9083 35.1113 21.6215 35.053 21.3395 34.9363C21.0576 34.8197 20.8 34.6544 20.5666 34.4405L18.2916 32.1947Z",
    fill: "#915DE8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElite);
export default __webpack_public_path__ + "static/media/elite.deafa7494f5be93064d662cdb336476f.svg";
export { ForwardRef as ReactComponent };